import React, { useContext } from 'react';
import { ExperimentOutlined, PlusOutlined } from '@ant-design/icons';
import { Badge, Button, Space, Typography } from 'antd';

import TicketAssignmentEditDrawer from '@totem/components/ticketing/assignments/TicketAssignmentEditDrawer';
import TicketAssignmentsContext from '@totem/components/ticketing/assignments/TicketAssignmentsContext';
import TicketAssignmentsTable from '@totem/components/ticketing/assignments/TicketAssignmentsTable';
import TicketAssignmentTestModal from '@totem/components/ticketing/assignments/TicketAssignmentTestModal';
import DropDownFilters from '@totem/components/ui_components/reportSettings/dropDownFilters';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import { FilterField } from '@totem/components/ui_components/reportSettings/types';

// Filtering/sorting runs client-side over the already-fetched entries (see TicketAssignmentsTable).
// Filter keys must match each config's `key`.
const FILTER_KEYS = ['status', 'ticketType', 'organization', 'partyType'];

const filterField = (key: string, label: string): FilterField => ({
  key,
  label,
  sortField: key === 'status' ? 'status' : '',
  filterField: key,
  multiple: true,
  values: [],
  options: [],
});

const FILTER_CONFIG: FilterField[] = [
  filterField('status', 'Status'),
  filterField('ticketType', 'Ticket Type'),
  filterField('organization', 'Organization'),
  filterField('partyType', 'Role'),
];

export const TicketAssignmentsExtra = () => {
  const { assignments, canEdit, onAdd, onTestOpen } = useContext(
    TicketAssignmentsContext,
  );

  return (
    <Space>
      <Badge count={assignments.length} overflowCount={999} offset={[0, -7]}>
        Assignments&nbsp;&nbsp;
      </Badge>
      <Button size="small" icon={<ExperimentOutlined />} onClick={onTestOpen}>
        Test Match
      </Button>
      {canEdit && (
        <Button size="small" icon={<PlusOutlined />} onClick={onAdd}>
          Add Assignment
        </Button>
      )}
    </Space>
  );
};

const TicketAssignmentsLayout = () => (
  <>
    <Typography.Paragraph type="secondary">
      When a ticket is created, entries are checked in sequence order. The first
      Active entry that matches the ticket and finds at least one Assignee adds
      its people to the ticket; if none of an entry&apos;s Assignees can be
      found (e.g. the organization has no contact with that label), the next
      matching entry is tried. Each entry is kept in sync with a generated rule.
    </Typography.Paragraph>
    <InputContainer
      componentKey="admin.ticketAssignments"
      componentLabel="Ticket Assignments"
      filterConfig={FILTER_CONFIG}
      defaultPageSize={20}
    >
      <DropDownFilters keys={FILTER_KEYS} extra={null} showFilterChips />
      <TicketAssignmentsTable />
    </InputContainer>
    <TicketAssignmentEditDrawer />
    <TicketAssignmentTestModal />
  </>
);

export default TicketAssignmentsLayout;
